import { TinyColor } from '@ctrl/tinycolor';
import { font, shape, spacing, typography, breakpoints, colors as jitsiColors, colorMap as jitsiColorMap, } from 'jitsi/base/ui/Tokens';
import { createWebTheme } from 'jitsi/base/ui/functions.web';
const loadOptions = () => {
    const options = localStorage.getItem('conference_options');
    if (!options)
        return;
    const result = JSON.parse(options);
    const replacementColor = result?.branding_secondary_color;
    if (!replacementColor)
        return { colors: jitsiColors, colorMap: jitsiColorMap };
    const color = new TinyColor(replacementColor);
    const colors = { ...jitsiColors };
    colors.iisightBrand = replacementColor;
    colors['iisightBrand700'] = color.darken(20).toHexString();
    colors['iisightBrand900'] = color.darken(30).toHexString();
    colors['iisightGreen100'] = color.lighten(42).toHexString();
    const colorMap = { ...jitsiColorMap };
    return { colors, colorMap };
};
let theme;
export const getTheme = () => {
    if (theme)
        return theme;
    const options = loadOptions();
    if (!options)
        return;
    const newTheme = createWebTheme({
        font,
        spacing,
        shape,
        typography,
        breakpoints,
        colors: options.colors,
        colorMap: options.colorMap,
    });
    theme = newTheme;
    return newTheme;
};
